import { Product } from './product.interface.ts';

export interface OrderProducts {
    id?: any;

    /**
     * @description Product is valid LuxuraProduct Id
     */
    product: Product;

    /**
     * @description Quantity must be positive number
     */
    quantity: number;

    /**
     * @description Price is LuxuraProduct sellPrice
     */
    price?: number;
}
